<div>{{translatedText}}</div>